export function useInputNumControls() {
  function InputNumControls(group) {
    if (!(group instanceof Element)) {
      return;
    }

    const up = group.querySelector(".inc");
    const down = group.querySelector(".dec");
    const input = group.querySelector('[type="number"]');

    function increment() {
      let val = parseInt(input.value);
      val += 1;
      input.value = val;
    }

    function decrement() {
      let val = parseInt(input.value);
      if (val > 0) {
        val -= 1;
      }
      input.value = val;
    }

    up.addEventListener("click", increment);
    down.addEventListener("click", decrement);
  }

  const inputNumControlGroups = document.querySelectorAll(
    ".input-num-w-buttons"
  );

  inputNumControlGroups.forEach((group) => InputNumControls(group));
}
